import React, { useEffect, useState } from 'react';
import { Routes, Route, useNavigate, Navigate as Redirect } from 'react-router-dom';
import AuthGuard from './AuthGuard';
import Sidebar from './shared/components/Sidebar';
import Header from './shared/components/Header';
import { WithOutPermissionRoutes, authenticatedRoutes } from './Routes';
import Login from './modules/auth/login';
import { useSelector } from 'react-redux';
import { RootState } from './store';
import { ToastContainer } from 'react-toastify';
import AppPermission from './AppPermission';

const ForgotPassword = React.lazy(() => import('./modules/auth/forgot-password'));
const ResetPassword = React.lazy(() => import('./modules/auth/reset-password'));
const PrivacyPolicy = React.lazy(() => import('./modules/privacy-policy'));

const AppRoutes = () => {
	const navigate = useNavigate();

	const { isLoggedin, isLoggedout } = useSelector((state: RootState) => state.auth);

	// const dispatch: Dispatch = useAppDispatch();
	// React.useEffect(() => {
	// 	// Listen for changes in localStorage
	// 	window.addEventListener('storage', handleStorageChange);

	// 	return () => {
	// 		// Clean up the event listener when the component unmounts
	// 		window.removeEventListener('storage', handleStorageChange);
	// 	};
	// }, []);

	// const handleStorageChange = () => {
	// 	dispatch(validateUser());
	// };

	// useEffect(() => {
	// 	if (!isLoggedin && isLoggedout) {
	// 		console.log('isLoggedout');
	// 		navigate('/');
	// 	}
	// }, [isLoggedout, isLoggedin]);

	return (
		<>
			<ToastContainer
				position='top-right'
				autoClose={2000}
				hideProgressBar={true}
				newestOnTop={false}
				rtl={false}
				pauseOnFocusLoss
				draggable
				closeButton={false}
				pauseOnHover
			/>
			<Routes>
				<Route index element={<Login />} />
				<Route path='/login' element={<Login />} />
				<Route index path='/forgot-password' element={<ForgotPassword />} />
				<Route path='/reset-password' element={<ResetPassword />} />
				<Route path='/privacy-policy' element={<PrivacyPolicy />} />

				{isLoggedout ? (
					<Route path='/*' element={<Redirect to='/' />} />
				) : (
					<Route element={<AuthGuard isLoggedIn={isLoggedin} />}>
						{WithOutPermissionRoutes?.map(
							({ element: Element, path, sidebar, header }) => (
								<Route
									path={`${path}`}
									key={path}
									element={
										<div>
											{header && <Header />}
											<div className='App'>
												{sidebar && <Sidebar />}
												<div className='content-wrapper'>
													<Element />
												</div>
											</div>
										</div>
									}
								/>
							)
						)}

						{authenticatedRoutes.map(
							({ element: Element, path, sidebar, header, all, accessKey, view }) => {
								// console.log(all, view, accessKey);
								return (
									<Route
										element={
											<AppPermission all={all} accessKey={accessKey} view={view} />
										}
										key={path}
									>
										<Route
											path={`${path}`}
											key={path}
											element={
												<div>
													{header && <Header />}
													<div className='App'>
														{sidebar && <Sidebar />}
														<div className='content-wrapper'>
															<Element />
														</div>
													</div>
												</div>
											}
										/>
									</Route>
								);
							}
						)}
					</Route>
				)}
			</Routes>
		</>
	);
};
export default AppRoutes;
